
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Utils
import { sortByNameInAlphabeticalOrder } from '../../../utils/miscellaneous/sortings';

// Components
import { ConditionalRendering } from '../../../components/common/conditional-rendering';

interface ITag {
    id: number,
    count: number,
    workGroupCount: number,
    name: string
}

interface ITagItems {
    deleteItem: (id: number) => void,
    isDeletable: boolean,
    items: Array<ITag>
}

const TagItems = (props: ITagItems) => {

    const {
        deleteItem,
        isDeletable,
        items = []
    } = props;

    return sortByNameInAlphabeticalOrder(items).map((item: ITag) => {

        const { name, id } = item;

        return (
            <div key = { id } className = 'manage-tag-ui' data-testid="manage-tags-edit-tag-item-main-container">
                { name }
                {
                    <ConditionalRendering isTrue={isDeletable}>
                        <div className = "attribute-cross-button" data-testid="manage-tags-edit-tag-item-container">
                            <a
                                href = { undefined }
                                onClick = { () => deleteItem(id) }
                                aria-label = "Close"
                                data-testid="manage-tags-edit-tag-item-anchor"
                            >
                                <FontAwesomeIcon icon = "times"/>
                            </a>
                        </div>
                    </ConditionalRendering>
                }
            </div>
        );
    });
};

export default TagItems;